import { getTranslations } from "../../../features/translations/translationsUtils"

export const getTimeInHours = (time: number = 0) => {
  if (time === 1) {
    return getTranslations('HOME_ONE_HOUR');
  }
  return getTranslations('HOME_TIME_IN_HOURS', [time]);
}